<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">Главная</el-breadcrumb-item>
                                    <el-breadcrumb-item>Расчет алиментов</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                    <card shadow class="card-profile mt--200 card_radius_no" no-body>
                        <div class="px-4">
                            <div class="mt-2 py-5 text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-11">
                                        <div class="calculator">
                                            <div class="calc-left">
                                                <el-row :gutter="10">
                                                    <el-col :span="24">
                                                        <label>{{$t('aliment.aliment_ishlaydi')}}</label><br/>
                                                        <el-select v-model="form.work" size="mini"
                                                                   :placeholder="$t('aliment.aliment_tanlang')"
                                                                   clearable style="width: 100%;">
                                                            <el-option
                                                                    v-for="item in work"
                                                                    :key="item.value"
                                                                    :label="$t(item.title)"
                                                                    :value="item.value">
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="24" v-if="form.work === 1">
                                                        <label>{{$t('aliment.aliment_oylik')}}</label><br/>
                                                        <el-input-number v-model="form.salary" type="" size="mini"
                                                                         :controls="false" :max="99999999999999999999"
                                                                         style="width: 100%;"></el-input-number>
                                                    </el-col>
                                                    <el-col :span="24">
                                                        <label>{{$t('aliment.aliment_farzand')}}</label><br/>
                                                        <el-select v-model="form.children"
                                                                   :placeholder="$t('aliment.aliment_tanlang')"
                                                                   size="mini" clearable
                                                                   style="width: 100%;  margin-bottom: 20px;">
                                                            <el-option
                                                                    v-for="item in children"
                                                                    :key="item.value"
                                                                    :label="$t(item.title)"
                                                                    :value="item.value">
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                </el-row>
                                                <el-button @click="clear">{{$t('ozod_muddat.ozod_tozalash')}}
                                                </el-button>
                                                <el-button type="primary" @click="calculate">
                                                    {{$t('ozod_muddat.ozod_hisoblash')}}
                                                </el-button>
                                            </div>
                                            <div class="calc-right">
                                                <div style="color: #7867F2; font-weight: 700; font-size: 28px; line-height: 40px; margin-bottom: 0;">
                                                    <span v-if="form.answerMoney !== null"
                                                          v-html="$t('aliment.answer', [form.answerMoney])"></span>
                                                    <span v-else style="font-size: 20px; color: #c7c7c7;">{{$t('aliment.aliment_maydon')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    work: 1,
                    salary: null,
                    children: null,
                    answerMoney: null
                },
                min_salary: 223000,
                avg_monthly_salary: 1491091.9,
                work: [
                    {
                        value: 1,
                        title: 'aliment.aliment_tanlash_sel'
                    },
                    {
                        value: 0,
                        title: 'aliment.aliment_tanlash_sel2'
                    }
                ],
                children: [
                    {
                        value: 1,
                        title: 'aliment.aliment_tanlash_sel3'
                    },
                    {
                        value: 2,
                        title: 'aliment.aliment_tanlash_sel4'
                    },
                    {
                        value: 3,
                        title: 'aliment.aliment_tanlash_sel5'
                    }
                ]
            };
        },
        methods: {
            format() {
                let theString = arguments[0];

                for (let i = 1; i < arguments.length; i++) {
                    let regEx = new RegExp("\\{" + (i - 1) + "\\}", "gm");
                    theString = theString.replace(regEx, arguments[i]);
                }

                return theString;
            },
            clear() {
                this.form.work = 1;
                this.form.salary = null;
                this.form.children = null;
                this.form.answerMoney = null;
            },
            calculate() {
                if (this.form.work === 1) {
                    let str = 0;
                    let amount = null;
                    if (this.form.salary > 0) {
                        amount = parseFloat(this.form.salary);
                    } else {
                        amount = 0;
                    }
                    switch (this.form.children) {
                        case 1:
                            str = amount / 4;
                            break;
                        case 2:
                            str = amount / 3;
                            break;
                        case 3:
                            str = amount / 2;
                            break;
                    }

                    if (str < (this.min_salary / 100 * 75)) {
                        str = this.min_salary / 100 * 75;
                    }

                    this.form.answerMoney = str.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
                } else if (this.form.work === 0) {
                    let str = 0;

                    switch (this.form.children) {
                        case 1:
                            str = parseFloat(this.avg_monthly_salary) / 4;
                            break;
                        case 2:
                            str = parseFloat(this.avg_monthly_salary) / 3;
                            break;
                        case 3:
                            str = parseFloat(this.avg_monthly_salary) / 2;
                            break;
                    }

                    this.form.answerMoney = str.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
                } else {
                    this.form.answerMoney = '0.0';
                }
            }

        },
    };
</script>
<style scoped>
    .calculator {
        display: flex;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 5px;
        background-color: #f2f3f5;
        padding: 25px;
        flex-flow: row;
    }

    label {
        color: #777;
        font-weight: 400;
        margin-bottom: 8px;
    }

    .calc-left {
        width: 100%;
        padding-right: 25px;
    }

    .calc-right {
        display: flex;
        height: 178px;
        background: #fff;
        width: 100%;
        align-items: center;
        justify-content: center;
        font-size: 25px;
        color: #7867F2;
        border: 2px dotted #ddd;
    }

    select#section {
        width: 100%;
    }

</style>
